export default __webpack_public_path__ + "static/media/blob_01.a3c020ed.mp4";